module.exports = __webpack_public_path__ + "img/637.17ed6ca7.jpg";